import axios from 'axios';

const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

export function getToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ''; } catch (_) { return ''; }
}

export function setToken(token) {
  try { localStorage.setItem(TOKEN_KEY, token); } catch (_) {}
  applyAxiosAuth(token);
}

export function clearToken() {
  try { localStorage.removeItem(TOKEN_KEY); } catch (_) {}
  try { localStorage.removeItem(USER_KEY); } catch (_) {}
  applyAxiosAuth('');
}

let axios401Attached = false;
function attachAxios401Interceptor() {
  if (axios401Attached) return;
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (status === 401) {
        try { clearToken(); } catch (_) {}
        try { window.dispatchEvent(new CustomEvent('sparta:unauthorized')); } catch (_) {}
      }
      return Promise.reject(error);
    }
  );
  axios401Attached = true;
}

export function applyAxiosAuth(token) {
  attachAxios401Interceptor();
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
}

export async function authFetch(input, init = {}) {
  const token = getToken();
  const headers = new Headers(init.headers || {});
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const res = await fetch(input, { ...init, headers });
  if (res.status === 401) {
    try { clearToken(); } catch (_) {}
    try { window.dispatchEvent(new CustomEvent('sparta:unauthorized')); } catch (_) {}
  }
  return res;
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) { return null; }
}

export function setStoredUser(user) {
  try { localStorage.setItem(USER_KEY, JSON.stringify(user || null)); } catch (_) {}
}
